import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DiscountCodeBookingsComponent } from './dialogs/bookings/discount-code-bookings.component'
import { DiscountCodeDialogComponent } from './dialogs/discount-code-dialog.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { DiscountDialogService } from './discount-dialog.service'
import { DiscountCodeLogsComponent } from './dialogs/logs/discount-code-logs.component'

const components = [DiscountCodeBookingsComponent, DiscountCodeLogsComponent]

const dialogs = [DiscountCodeDialogComponent]

@NgModule({
  declarations: [...dialogs, ...components],
  entryComponents: [...dialogs],
  exports: [...components],
  providers: [DiscountDialogService],
  imports: [CommonModule, SharedModule],
})
export class DiscountsModule {}
